<!-- eslint-disable max-len -->
<template>
  <svg fill="none" height="14" viewBox="0 0 11 14" width="11" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 5.46341C10.5 6.08786 10.2075 6.90689 9.70206 7.83008C9.2046 8.73864 8.53514 9.68758 7.85624 10.5551C7.17882 11.4207 6.50014 12.1949 5.99018 12.7533C5.80003 12.9615 5.63367 13.1393 5.5 13.2803C5.36633 13.1393 5.19997 12.9615 5.00982 12.7533C4.49986 12.1949 3.82118 11.4207 3.14376 10.5551C2.46486 9.68758 1.7954 8.73864 1.29794 7.83008C0.792472 6.90689 0.5 6.08786 0.5 5.46341C0.5 2.72534 2.73542 0.5 5.5 0.5C8.26458 0.5 10.5 2.72534 10.5 5.46341Z"
    />
    <circle cx="5.5" cy="5.5" r="2" />
  </svg>
</template>
